import {
   ReactQuery,
   displayAndLogErrorWithMessage,
   useAlerts
} from "@msidata/zeact";
import { useAppContext } from "../data/AppContext";

const queryConfig = {
   suspense: false,
   cacheTime: 0
};

export const useIsUserGroupAdmin = (
   userId: number | null,
   groupName: string | null
): any => {
   const { apiClient } = useAppContext();
   const { issueAlert } = useAlerts();

   const fetchIsUserGroupAdmin =
      userId && groupName
         ? () =>
              apiClient
                 .request({
                    url: `Administration/IsUserGroupAdmin`,
                    params: {
                       userId,
                       groupName
                    }
                 })
                 .then(response => response.data.d.results)
                 .catch(error => {
                    displayAndLogErrorWithMessage(
                       error,
                       "IsUserGroupAdminErrorMessage",
                       issueAlert
                    );
                    return Promise.resolve(false);
                 })
         : () => {
              return Promise.resolve(false);
           };

   const { data, isFetching } = ReactQuery.useQuery(
      ["IsUserGroupAdmin", { userId, groupName }],
      fetchIsUserGroupAdmin,
      queryConfig
   );

   return {
      isUserGroupAdmin: data,
      pending: isFetching
   };
};
